export const config = {
  appVersion: "0.0.1",
//  url: "http://localhost:9098",
  url: "https://ntn-api.portnet.ma",
};
